import { defineMessages } from 'react-intl-next';

export const i18n: {
	salesforceStageFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	salesforceStageFilterLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	salesforceStageFilterLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	salesforceStageFilterLabel: {
		id: 'search-page.salesforce.filter.stage',
		defaultMessage: 'Stage',
		description: 'Label for filtering by Salesforce opportunity stage',
	},
	salesforceStageFilterLabelSelected: {
		id: 'search-page.salesforce.filter.stage.label.selected',
		defaultMessage: 'Selected',
		description: 'Salesforce stage filter label for selected options',
	},
	salesforceStageFilterLabelUnselected: {
		id: 'search-page.salesforce.filter.stage.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Salesforce stage filter label for unselected options',
	},
});
